import React from 'react';
import mergedViewsIllustration from './assets/merged-views-illustration.png';

export const MergedViewsIllustration = () => (
	<img src={mergedViewsIllustration} alt="" width="320" />
);
